import { default as ModuleContext } from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { ModalWrapper } from 'components/ModalWrapper';
import { useForceRender } from 'hooks/useForceRender';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { IGridData } from 'types/models';
import { EditorRow, TextFieldStyled } from 'components/common/styles';
import Button from '@material-ui/core/Button';
import ChartModel, { IChart } from '../../../models/ChartModel';

type IProps = {
  onClose: () => void;
  onChooseChart?: (data: IChart) => void;
  onNewChart?: (name: string) => void;
};

const ChartSelectNewModal: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();

  const [name, setName] = useState('');

  const moduleModel = useContext(ModuleContext);

  const chartModel = useMemo(() => new ChartModel({ render: forceRender, courseId: moduleModel.courseId }), [
    forceRender,
    moduleModel.courseId,
  ]);

  useEffect(() => {
    chartModel.getGrid();
  }, [chartModel]);

  const handleRowClick = (data: IGridData) => {
    props.onChooseChart && props.onChooseChart(data as IChart);
  };

  const handleNew = () => {
    props.onNewChart && props.onNewChart(name);
  };

  return (
    <ModalWrapper title="Search Chart" width={468} height={555} onClose={props.onClose}>
      <ModuleContext.Provider value={chartModel}>
        <EditorRow>
          <p>
            <b>Select Chart or create a new one</b>
          </p>
        </EditorRow>
        <Grid handleRowClick={handleRowClick} />
        <EditorRow>
          <TextFieldStyled onChange={(event) => setName(event.target.value)} label={'Name'} />
          <Button variant="contained" size="small" color="primary" onClick={handleNew}>
            new
          </Button>
        </EditorRow>
      </ModuleContext.Provider>
    </ModalWrapper>
  );
};

export default ChartSelectNewModal;
